module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAPxJREFUKBWVki9vwmAQxrkGV8nkHLNoQibw6AWBQDVtMrVPgEBts0uW9J9pUoMHTc3Cd+AzIBEV7cvvJbmlfdXW5HL33PPcn/dSGThfURR+Xddj0o/GmB3mq0REDqLAekhJ0/QE8UU8wS5RFH2qJo5j4yF4yfN8ZpPEK5wEQVCqyPVe27bHpmlKxGvId+yNCcYVKr6vlGXZE0VnhD9hGD5bMkmSDW7KWtWvWGTTe4MS1rPvAw1eCbuProassqDLvCO+gr87uBcOIe3ptpql6xxT2FuJ5M4W+M7pBhSMbAVc5XAfnrb6q/93gXC+PaMXOoF1rtjSYvK9X4PU/gbiJXbWrZNnBwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat/all.png
// module id = 6NZO
// module chunks = 0